<template>
    <div>
      <!-- Your component's template -->
      <!-- <button @click="openChat">Open Chat</button> -->
    </div>
  </template>
  
  <script>
  export default {
    created() {
        // this.openChat()
    },
    methods: {
      openChat() {
        // Load Zendesk Chat Widget script dynamically
        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = 'https://static.zdassets.com/ekr/snippet.js?key=676eb90f-1b65-49c8-9e5e-df9df1ebd4db';
        script.async = true;
        script.onload = this.initializeChat;
        document.head.appendChild(script);
      },
      initializeChat() {
        // Call the Zendesk Chat API function to open the chat
        if (window.zESettings) {
          window.zESettings.webWidget.open();
        } else {
          console.error('Zendesk Chat API not initialized.');
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Your component's styles */
  </style>